























































































































import Vue from 'vue'
import { app } from '@/firebase'
import ExtendableList from '@/components/Profile/ExtendableList.vue'
import DateField from '@/components/Profile/DateField.vue'

type VFormElement = Vue & {
    validate: () => boolean
    valid: boolean
}
/**
 * This is considered to be a child of a form
 */
export default Vue.extend({
    name: 'ProfileSection',
    components: { ExtendableList, DateField },
    props: {
        section: String,
        data: Object,
        setContactPrivacy: Function, // only used for contactKeys section
        uemails: Array,
    },
    data: () => ({
        fields: {
            accountInfoKeys: [
                { key: 'name', type: 'text', required: true },
                { key: 'uemail', type: 'email', required: true },
            ],
            basicInfoKeys: [
                { key: 'title', type: 'text', col: 2 },
                { key: 'firstNameEng', type: 'text', col: 5, required: true },
                { key: 'lastNameEng', type: 'text', col: 5, required: true },
                { key: 'gender', type: 'radio', options: ['female', 'male', 'other', 'na'], required: true },
                { key: 'residence', type: 'combobox', col: 6, required: true },
                { key: 'postcode', type: 'text', col: 6 },
                { key: 'arriveGermanyAt', type: 'month', col: 6, required: true },
                { key: 'leaveGermanyAt', type: 'month', col: 6 },
                { key: 'birthdate', type: 'date', col: 6 },
                { key: 'birthplace', type: 'text', col: 6 },
            ],
            contactKeys: [
                { key: 'emails', type: 'emailList' },
                { key: 'phoneNumber', type: 'text', required: true },
                { key: 'wechat', type: 'text', col: 4 },
                { key: 'github', type: 'text', col: 4 },
                { key: 'facebook', type: 'text', col: 4 },
            ],
            alumniInfoKeys: [
                { key: 'workplace', type: 'text', col: 6 },
                { key: 'workposition', type: 'text', col: 6 },
                { key: 'profArea', type: 'textList' },
                { key: 'thuMajor', type: 'comboboxList', required: true },
                { key: 'enrollmentTime', type: 'month', col: 6, required: true },
                { key: 'graduationTime', type: 'month', col: 6 },
            ],
        },
        residenceOptions: [],
        majorOptions: [],
        uemailValid: false,
        uemailPendingIcon: '',
    }),
    methods: {
        getResidenceOptions() {
            app.functions()
                .httpsCallable('getAllResidences')()
                .then((res) => {
                    this.residenceOptions = res.data
                })
        },
        checkUemail() {
            this.uemailPendingIcon = 'pending'
            ;(this.$refs.uemailField as Array<VFormElement>)[0].validate()
            app.functions()
                .httpsCallable('checkUemail')(this.data.uemail)
                .then((res) => (this.uemailValid = res.data))
                .then(() => {
                    ;(this.$refs.uemailField as Array<VFormElement>)[0].validate()
                    this.uemailPendingIcon = this.uemailValid ? 'mdi-check-bold' : 'mdi-close-thick'
                    ;(this.$refs.uemailField as Array<VFormElement>)[0].validate()
                    this.uemailPendingIcon = (this.$refs.uemailField as Array<VFormElement>)[0].valid
                        ? 'mdi-check-bold'
                        : 'mdi-close-thick'
                })
        },
        clearUemailValidationiStatus() {
            this.uemailValid = false
            this.uemailPendingIcon = ''
        },
    },
})
